export const TypeLineItemProductCustomAttributeRequiredError = "product_custom_attribute_required_error"
export const TypeNotFound = "not_found"
export const TypeAuthError = "auth_error"
export const TypeUserAlreadyExists = "user_already_exists"
export const TypeInternalError = "not_found"
export const TypePaymentError = "payment_error"
export const TypePaymentBankAccountExistsError = "payment_bank_account_exists"
export const TypeNoRetryError = "no_retry"
export const TypeExternalIntegrationAccountExpired = "external_integration_account_expired"
export const TypeOperationAbortedError = "operation_aborted_error"
export const TypeCustomFieldRequiredError = "custom_field_required_error"


// WEBPACK FOOTER //
// ./src/state/helpers/ErrorTypes.ts